<script setup>
import {ref, computed, onMounted} from 'vue';
import MbCalcLayBetComponent from "@/components/matched_betting_calc/MbCalcLayBetComponent.vue";
import MbCalcBackBetComponent from "@/components/matched_betting_calc/MbCalcBackBetComponent.vue";
import MbCalcEwResultsComponent from "@/components/matched_betting_calc/MbCalcEwResultsComponent.vue";
import BetCalcOddsType from "@/components/bet_calc/BetCalcOddsType.vue";
import {getPlaceOdds} from "@/services/getPlaceOdds";
import {useRoute, useRouter} from "vue-router";

const route = useRoute();
const router = useRouter()

const backBet = ref({
  odds: '2',
  stake: '',
  commission: 0,
  type: 'qualifying',
  eachWayTerms: '1.2'
});

const layWin = ref({
  commission: 2,
  odds: ''
});

const layPlace = ref({
  commission: 2,
  odds: ''
});

const oddsType = ref('decimal');

onMounted(() => {
  const newQuery = route.query;
  backBet.value.odds = newQuery.backOdds || '2';
  backBet.value.stake = newQuery.backStake || '';
  backBet.value.commission = newQuery.backCommission || 0;
  backBet.value.type = newQuery.backType || 'qualifying';
  backBet.value.eachWayTerms = newQuery.ewTerms || '1.2';
  layWin.value.odds = newQuery.layWinOdds || '';
  layPlace.value.odds = newQuery.layPlaceOdds || '';
  dataReady.value = true

  // Remove query string from URL
  router.replace({ path: route.path });
});

const placeBackBet = computed(()=>{
  return {...backBet.value, odds: getPlaceOdds(backBet.value.odds, backBet.value.eachWayTerms) }
})

const dataReady = ref(false);


</script>


<template>
  <div v-if="dataReady" class="mb-calc-ew-container">
    <BetCalcOddsType v-model="oddsType"/>


    <!-- Back Bet Component -->
    <mb-calc-back-bet-component
        label="Back Bet"
        :back-data="backBet"
        :odds-type="oddsType"
        @update:backData="newBackData => backBet = newBackData"
    />

    <!-- Lay Bet for the Win -->
    <mb-calc-lay-bet-component
        label="Lay the Win"
        :back-data="backBet"
        :lay-data="layWin"
        :odds-type="oddsType"
        @update:layData="newLayWin => layWin = newLayWin"
    />

    <!-- Lay Bet for the Place -->
    <mb-calc-lay-bet-component
        label="Lay the Place"
        :back-data="placeBackBet"
        :lay-data="layPlace"
        :odds-type="oddsType"
        @update:layData="newLayPlace => layPlace = newLayPlace"
    />

    <mb-calc-ew-results-component
        :win-back-bet="backBet"
        :win-lay-bet="layWin"
        :place-back-bet="placeBackBet"
        :place-lay-bet="layPlace"
    />

  </div>
</template>


<style scoped>
.mb-calc-ew-container {
  max-width: 768px;
  margin: 0 auto;
}

</style>